import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as NewsActionCreators from "../../../actions/news.actions";
import * as CreDtos from "../../../CRE.dtos";
import InlineTextDisplay from '../../Controls/InlineTextDisplay';
import InlineTextEdit from '../../Controls/InlineTextEdit';
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';

export interface INewsProps {
    news: CreDtos.News;
    cancel: Function;
    upsert: Function;
    isSaving: boolean;
}

interface INewsState {
    news: CreDtos.News;
}

class NewsItem extends React.Component<INewsProps, INewsState> {
    constructor(props: INewsProps) {
        super(props);
        this.state = {
            news: new CreDtos.News()
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.setState({ news: { ...this.props.news } });
    }

    componentDidUpdate(prevProps) {
        if (this.state.news.id != this.props.news.id) {
            this.setState({ news: { ...this.props.news } });
        }
    }

    onValueChanged(fieldName: string, value: any) {
        var news = { ...this.state.news };
        news[fieldName] = value;
        this.setState({ news })
    }

    onSave() {
        this.props.upsert(this.state.news);
    }

    render() {
        let content;

        if (this.state.news) {

            let img = this.state.news.img;
            if (!img || img.length == 0) {
                img = "./images/Unconfirmed.png";
            }

            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12 col-md-9 push-md-3">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>News</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.title}
                                                onChange={(e) => this.onValueChanged("title", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Date using the format 1 Jan 2020..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.date}
                                                onChange={(e) => this.onValueChanged("date", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Sub title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.subtitle}
                                                onChange={(e) => this.onValueChanged("subtitle", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Anchor..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.anchor}
                                                onChange={(e) => this.onValueChanged("anchor", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>

                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.news.text} onChange={value => this.onValueChanged("text", value)} />
                                        </div>
                                    {false && (
                                        <div className="col-12 mb-1 ">
                                            <div className="mb-0 form-group">
                                                <InlineTextDisplay source={this.state.news.text} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-12 mb-1 ">
                                        <UploadTemporaryFile 
                                            isImage={true} 
                                            onUpdated={(path) => this.onValueChanged("img", path)} 
                                            text='Choose Image'
                                        />
                                        <p>The preferred aspect ratio 5:4</p>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Image caption..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.caption}
                                                onChange={(e) => this.onValueChanged("caption", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    
                                    </div>
                                    </div>
                                        <div className="col-12 mb-1">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="Read more link https:// ..."
                                                disabled={this.props.isSaving}
                                                value={this.state.news.link}
                                                onChange={(e) => this.onValueChanged("link", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                        <div className="col-12 mb-1">
                                            <UploadTemporaryFile
                                                onUpdated={(path) => this.onValueChanged("link", path)} 
                                                allowedFileTypes={[".pdf", ".doc", ".docx", ".ppt", ".pptx", ".odt"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 show-sm">
                                        <div>
                                            <img src={img}  style={{width: "100%"}} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.news.promoted}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("promoted", !this.state.news.promoted)}
                                            />
                                            Promoted
                                    </label>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.news.enabled}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("enabled", !this.state.news.enabled)}
                                            />
                                            Enabled
                                    </label>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.cancel()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-md-3 pull-md-9 hide-sm">
                                <div>
                                    <img src={img} style={{width: "100%"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            );
        }

        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        news: state.news.newsItem,
        isSaving: state.news.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            cancel: NewsActionCreators.newsCancel,
            upsert: NewsActionCreators.newsUpsertRequest
        },
        dispatch
    );
};


const NewsItemContainer = connect(mapStateToProps, mapDispatchToProps)(
    NewsItem
);

export default NewsItemContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/News/NewsItem.tsx